import { Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import Dashboard from "./Pages/Dashboard";
import { AlertProvider } from "./contexts/alertContext";
import Login from "Pages/Auth/Login";
import { I18nextProvider } from "react-i18next";
import i18n from "./utils/i18n";
import Register from "Pages/Auth/Login/Register";
import WorkshopEnrollment from "Pages/WorkshopEnrollment";
import CertificateVerification from "Pages/CertificateVerification";

const App: React.FC = () => {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <AlertProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register/:id" element={<Register/>} />
            <Route path="/workshop-enrollment/:workshopId" element={<WorkshopEnrollment />} />
            <Route path="/CertVer/:enrollmentId" element={<CertificateVerification />} />
            <Route path="/*" element={<Dashboard />} />
          </Routes>
        </AlertProvider>
      </I18nextProvider>
    </QueryClientProvider>
  );
};

export default App;
